export const mascaraCnpj = (v: string) => {
    if (v) {
        v = v.substring(0, 18);
        v = v.replace(/\D/g, ''); // Remove tudo o que não é dígito
        v = v.replace(/^(\d{2})(\d)/, '$1.$2'); // 00.000000000000
        v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3'); // 00.000.000000000
        v = v.replace(/\.(\d{3})(\d)/, '.$1/$2'); // 00.000.000/000000
        v = v.replace(/(\d{4})(\d)/, '$1-$2'); // 00.000.000/0000-00

        return v;
    }
    return '';
};
